import createWidgetFactory from 'components-framework/widget/create_widget_factory';
import View from './view';
import Model from './model';
import {WIDGET_NAME} from './constants';

const factory = createWidgetFactory({
    name: WIDGET_NAME,
    modelClass: Model,
    viewClass: View,
    methods: {
        async initialize() {
            await this.model.initializeExpirationDate();
            this.render();
        },

        togglePendingMembershipReactivateDecisionMessage() {
            return this.togglePendingMembershipReactivateDecisionMessage();
        },
        toggleShowMembershipRecaptureWidget() {
            this.toggleShowMembershipRecaptureWidget();
        },

        triggerTrackingOnPayment() {
            this.triggerTrackingOnPayment();
        },

        handleOnContinueSuccess() {
            this.model.propagateMembershipProduct();
            this.renderConfirmationComponent();
            this.triggerTrackingOnContinue();
        },
    },
});

export default {
    factory,
};
